import { createGlobalStyle } from "styled-components"

export default createGlobalStyle`
  :root {
  --doc-height: 100%;
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html,
  body,
  #app {
    height: 100vh; /* fallback for Js load */
    height: var(--doc-height);
    width: 100vw;
    overscroll-behavior: none;
  }

  body {
    font-family: "Open Sans", sans-serif;
    font-weight: 600;
    color: white;
    line-height: 1.5;
    font-smooth: always;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button{
    text-decoration: none;
    background-color: transparent;
    border: none;
    color: white;
    :focus {
      outline: none;
    }
  }

  input,
  button,
  textarea,
  select {
    font: inherit;
  }
`
